import { render, staticRenderFns } from "./AddStockRequest.vue?vue&type=template&id=1494c588"
import script from "./AddStockRequest.vue?vue&type=script&lang=js"
export * from "./AddStockRequest.vue?vue&type=script&lang=js"
import style0 from "./AddStockRequest.vue?vue&type=style&index=0&id=1494c588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports